module.exports = __webpack_public_path__ + "img/nouSomni2_2.8264e1dd.jpg";